import gql from 'graphql-tag'

const fragment = gql`
    fragment getClientMessageFragment on ClientMessage {
        id
        mod_ver
        createdAt
        isForShop
        sender
        subject
        hasConfirm
        body(type: plain)
        recipientUsers {
          id
          name
        }
        recipientShops {
          id
          name
        }
        answer {
          code
          userId
          readAt
          shopId
          user {
            name
          }
          shop {
            name
          }
        }
    }
`

const query = gql`
query getClientMessage($id: ID!) {
	cashAssist {
		getClientMessage(id: $id) {
			...getClientMessageFragment
		}
	}
}
${fragment}`

export default query
